module.exports = __webpack_public_path__ + "img/yw_ycgl.6bea3a99.svg";